// test auto merge of dev with main

import React, { lazy, useEffect, useState } from 'react';

import client from 'apollo';
import locales from 'locales';
import decode from 'jwt-decode';
import MUIThemeProvider from 'theme';

import { IntlProvider } from 'react-intl';
import DirectionProvider from 'providers/DirectionProvider';
import { signOut } from 'toolkits/redux/auth';
import StyledChart from 'components/Chart/styles';
import { ToastContainer } from 'react-toastify';
import { ApolloProvider } from '@apollo/client';
import ScrollToTop from 'components/ScrollToTop';
import SplashScreen from 'components/SplashScreen';
import Loadable from 'components/Loadable';
import { useDispatch, useSelector } from 'react-redux';
import AuthenticationRoutes from 'routes/AuthenticationRoutes';
import hasRequiredRole from 'helpers/hasRequiredRole';

import 'styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';

const AppRoutes = Loadable(lazy(() => import('routes/AppRoutes')));
const SuperAdminRoutes = Loadable(lazy(() => import('routes/SuperAdminRoutes')));
// ----------------------------------------------------------------------

export default function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const {
    language: { language, direction },
  } = useSelector((state) => state.setting);
  const { isAuthenticated, userToken, userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userToken === null || decode(userToken).exp < Date.now() / 1000) {
      dispatch(signOut());
    }
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  const getContent = () => {
    if (!loading) {
      if (isAuthenticated && hasRequiredRole(['superadmin'], userInfo?.roles)) {
        return <SuperAdminRoutes />;
      } else if (isAuthenticated) {
        return <AppRoutes />;
      }
      return <AuthenticationRoutes />;
    }
    return <SplashScreen />;
  };

  return (
    <MUIThemeProvider>
      <DirectionProvider direction={direction}>
        <IntlProvider defaultLocale="fa" locale={language} messages={locales[language]}>
          <ToastContainer
            autoClose={1200}
            draggable
            closeButton={false}
            bodyStyle={{ direction }}
            position="bottom-center"
          />
          <ApolloProvider client={client}>
            <ScrollToTop />
            <StyledChart />
            {getContent()}
          </ApolloProvider>
        </IntlProvider>
      </DirectionProvider>
    </MUIThemeProvider>
  );
}
